import { VacanciesInfo } from "../components/pages/vacanciesInfo/VacanciesInfo";

export function VacanciesInfoPage(){

    return(
        <>
            <VacanciesInfo />
        </>
    );
}